export default __webpack_public_path__ + "static/media/Logo_secIT.aed6cbe3.png";